/* eslint-disable import/no-cycle */
import React from 'react';

import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

import { StatusLead } from 'const';
import { MODAL_CLOSE } from 'redux/slices/modals';
import { Button, Icon } from 'ui/atoms';
import { Container } from 'ui/gridSystem';
import MainFont from 'ui/typography/mainFont';

import Modal, { stopEvent } from '../Modal';
import {
  ButtonsContainer,
  IconClose,
  ModalGlobalContainer,
  ModalTitle,
  ModalWrapper
} from '../Modal.style';
import { ModalContainer, ModalContent, StatusContainer } from './style';

const modalId = 'LeadsStatusModal';

const LeadsStatusModal = ({ onClose, payload }) => {
  const { onAccept, cognitoId } = payload || {};

  const { t } = useTranslation();

  const handleConfirm = () => {
    onAccept(cognitoId);
    onClose();
  };

  return (
    <Modal id={modalId}>
      <Container>
        <ModalWrapper>
          <ModalGlobalContainer onMouseDown={stopEvent} onClick={stopEvent}>
            <ModalTitle>
              <MainFont type="peopleModalHeader">{t('change_status')}</MainFont>
              <IconClose>
                <Icon type="icon-close-modal" size={20} onClick={onClose} />
              </IconClose>
            </ModalTitle>
            <ModalContainer>
              <ModalContent>
                <div>
                  <MainFont type="peopleModalText">
                    {t('change_staus_lead_text_first_part', {
                      number: payload?.data?.length
                    })}
                  </MainFont>
                </div>
                <div>
                  <StatusContainer type={StatusLead.NEW}>
                    {t('new')}
                  </StatusContainer>{' '}
                  <MainFont type="peopleModalText">{t('to')} </MainFont>
                  <StatusContainer type={StatusLead.NOT_INTERESTED}>
                    {t('not_interested')}
                  </StatusContainer>
                  <MainFont type="peopleModalText">?</MainFont>
                </div>
              </ModalContent>
            </ModalContainer>
            <ButtonsContainer>
              <Button
                variant="popupCancel"
                buttonType="people_role_change"
                onClick={onClose}
              >
                {t('no_wait')}
              </Button>
              <Button
                variant="popupYes"
                onClick={handleConfirm}
                buttonType="people_role_change"
              >
                {t('change_leads_status')}
              </Button>
            </ButtonsContainer>
          </ModalGlobalContainer>
        </ModalWrapper>
      </Container>
    </Modal>
  );
};

LeadsStatusModal.id = modalId;

LeadsStatusModal.propTypes = {
  onClose: PropTypes.func,
  payload: PropTypes.object,
  targetRole: PropTypes.string
};

export default connect(
  state => ({
    payload: state.modals?.payload,
    targetRole: state?.people?.targetRole
  }),
  dispatch => ({ onClose: () => dispatch(MODAL_CLOSE()) })
)(LeadsStatusModal);
